import { useLanguage } from "@/contexts/LanguageContext";

export function LanguageToggle() {
  const { language, setLanguage } = useLanguage();
  const isGerman = language === "de";

  const toggleLanguage = () => {
    setLanguage(isGerman ? "en" : "de");
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 rounded-full bg-secondary border border-border hover:border-primary transition-colors cursor-pointer"
      aria-label={isGerman ? "Switch to English" : "Zu Deutsch wechseln"}
    >
      <span
        className={`text-xs font-bold uppercase tracking-wider transition-colors ${
          !isGerman ? 'text-primary' : 'text-muted-foreground'
        }`}
      >
        EN
      </span>
      <div className="relative w-11 h-6 rounded-full bg-muted pointer-events-none">
        <span
          className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-primary shadow-md transition-transform duration-300 ease-in-out ${
            isGerman ? 'translate-x-5' : 'translate-x-0'
          }`}
        />
      </div>
      <span
        className={`text-xs font-bold uppercase tracking-wider transition-colors ${
          isGerman ? 'text-primary' : 'text-muted-foreground'
        }`}
      >
        DE
      </span>
    </button>
  );
}
